import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=60c13812&scoped=true"
import script from "./DealCard.vue?vue&type=script&lang=js"
export * from "./DealCard.vue?vue&type=script&lang=js"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=60c13812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c13812",
  null
  
)

export default component.exports